<div>
	<form [formGroup]="form">
		<nz-form-item>
			<nz-form-label [nzSpan]="24" nzFor="comment" nzRequired>Comment</nz-form-label>
			<nz-form-control [nzSpan]="24" [nzErrorTip]="'Comment is required'">
				<textarea nz-input id="comment" formControlName="comment" rows="4"
					placeholder="Type your comment here..."></textarea>
			</nz-form-control>
		</nz-form-item>
	</form>
</div>

<div class="mt-4 text-right">
	<button nz-button nzType="default" (click)="cancel()">Cancel</button>
	<button nz-button nzType="primary" class="ml-2" [disabled]="form.invalid" (click)="submit()">
		Submit
	</button>
</div>
